
import { axiosLocal5000Local } from "../axios";
const api_project_repository = '/backoffice' 

async function postRequest(url: string, data: any) {
    try {
        const res = await axiosLocal5000Local.post(api_project_repository+url, data);
        return res?.data;
    } catch (error) {
        console.log(`Exception occurred while calling ${url}: `, error);
        return { "error": true };
    }
}

export async function getAutoSummaryDetails(backStartDate: any, backEndDate: any, backVersions: any, user: any) {
    return postRequest('/getSummaryDetails', {
        "startDate": backStartDate,
        "endDate": backEndDate,
        "version": backVersions,
        "user": user
    });
}

export async function getFundDetails(backStartDate: any, backEndDate: any, user: any) {
    return postRequest('/getFundDetails', {
        "startDate": backStartDate,
        "endDate": backEndDate,
        "user": user
    });
}

export async function updateExecutedTradeDetails(data: any) {
    return postRequest('/executed_update_trade_details', { "data": data });
}

export async function updateInitialBalanceDetails(data: any) {
    return postRequest('/update_initial_balance_details', { "data": data });
}

export async function insertHedgeTradeDetails(data: any) {
    return postRequest('/insert_hedge_trade_details', { "data": data });
}

export async function getAutoTradeDetails(backStartDate: any, backEndDate: any, backVersions: any, user: any) {
    return postRequest('/getAutoTrades', {
        "startDate": backStartDate,
        "endDate": backEndDate,
        "version": backVersions,
        "user": user
    });
}

export async function getUserPrivilege(user: any) {
    return postRequest('/getUserPrivilege', { "user": user });
}

export async function getAutoTradeModels() {
    return postRequest('/autofireModels', {});
}

export async function getSamcoDetails(backStartDate: any, backEndDate: any) {
    return postRequest('/get_records', {
        "startDate": backStartDate,
        "endDate": backEndDate
    });
}

export async function getRemarkText(modalCode: any, orderNumber: any, remarkdate: any, remarksContent: any, uuid: any) {
    return postRequest('/update_remarks', {
        "model_code": modalCode,
        "s_order_number": orderNumber,
        "date": remarkdate,
        "remarks": remarksContent,
        "uuid": uuid
    });
}

export async function getUserSymbols(user: any) {
    return postRequest('/getUserSymbol', { "user": user });
}